module.exports = __webpack_public_path__ + "media/images/icons/twotone/folder-open-3e3f51ec15f248d1a249a4d679e6d99c.svg";